import React from 'react';

export default function MentionsLegales() {
  return (
    <div className="bg-[#FAFAFA] min-h-screen pt-16" data-testid="mentions-legales-page">
      {/* Header */}
      <div className="py-16 px-4 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto text-center">
          <h1
            className="text-5xl font-black"
            style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
          >
            Mentions légales
          </h1>
          <p className="text-gray-400 text-sm mt-3">En vigueur au 20/09/2019</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-16">
        <div className="bg-white rounded-2xl border border-gray-100 p-8 sm:p-12 space-y-10 text-gray-700">

          <section data-testid="legal-article-1">
            <h2
              className="text-2xl font-black mb-4"
              style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
            >
              Article 1 : Les mentions légales
            </h2>
            <p className="text-sm leading-relaxed">
              Les présentes conditions générales d'utilisation (dites « CGU ») ont pour objet l'encadrement juridique
              des modalités de mise à disposition du site et des services par et de définir les conditions d'accès et
              d'utilisation des services par « l'Utilisateur ».
            </p>
            <p className="text-sm leading-relaxed mt-4">
              L'édition du site <strong>Grainette.fr</strong> est assurée par la Société <strong>SAS BARLES</strong> au capital de 20 000 euros,
              immatriculée au RCS de Paris sous le numéro <strong>752229617</strong>, dont le siège social est situé au{' '}
              <strong>16 rue Godot de Mauroy, 75009 Paris</strong>.
            </p>
            <div className="mt-4 space-y-1 text-sm">
              <p>Adresse e-mail : <a href="mailto:contact@grainette.fr" className="font-medium" style={{ color: '#80a890' }}>contact@grainette.fr</a></p>
              <p>Directeur de la publication : <strong>Barlogis Geoffrey</strong></p>
              <p>Hébergeur : <strong>IONOS (1&1)</strong> – INTERGEST SA, 7 Place de la Gare, 57200 Sarreguemines</p>
            </div>
          </section>

          <hr className="border-gray-100" />

          <section data-testid="legal-article-2">
            <h2
              className="text-2xl font-black mb-4"
              style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
            >
              Article 2 : Accès au site
            </h2>
            <p className="text-sm leading-relaxed">
              Le site Grainette.fr permet à l'Utilisateur un accès gratuit aux services suivants : présentation des
              restaurants, menus, informations de contact et click & collect. Le site est accessible gratuitement en
              tout lieu à tout Utilisateur ayant un accès à Internet. Tous les frais supportés par l'Utilisateur pour
              accéder au service (matériel informatique, logiciels, connexion Internet, etc.) sont à sa charge.
            </p>
          </section>

          <hr className="border-gray-100" />

          <section data-testid="legal-article-3">
            <h2
              className="text-2xl font-black mb-4"
              style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
            >
              Article 3 : Collecte des données
            </h2>
            <p className="text-sm leading-relaxed">
              Le site collecte les données des Utilisateurs uniquement dans le cadre des formulaires de contact et de
              recrutement (nom, prénom, email, téléphone, message). Ces données sont utilisées exclusivement pour
              traiter les demandes et candidatures. Conformément au RGPD, vous disposez d'un droit d'accès, de
              rectification et de suppression de vos données en nous contactant à{' '}
              <a href="mailto:contact@grainette.fr" style={{ color: '#80a890' }}>contact@grainette.fr</a>.
            </p>
          </section>

          <hr className="border-gray-100" />

          <section data-testid="legal-article-4">
            <h2
              className="text-2xl font-black mb-4"
              style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
            >
              Article 4 : Propriété intellectuelle
            </h2>
            <p className="text-sm leading-relaxed">
              Les marques, logos, signes ainsi que tous les contenus du site (textes, images, son…) font l'objet d'une
              protection par le Code de la propriété intellectuelle et plus particulièrement par le droit d'auteur.
              La marque <strong>Grainette</strong> est une marque déposée par BARLES. Toute représentation et/ou reproduction
              et/ou exploitation partielle ou totale de cette marque, de quelque nature que ce soit, est totalement
              prohibée.
            </p>
          </section>

          <hr className="border-gray-100" />

          <section data-testid="legal-article-5">
            <h2
              className="text-2xl font-black mb-4"
              style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
            >
              Article 5 : Responsabilité
            </h2>
            <p className="text-sm leading-relaxed">
              Les sources des informations diffusées sur le site Grainette.fr sont réputées fiables mais le site ne
              garantit pas qu'il soit exempt de défauts, d'erreurs ou d'omissions. Les informations communiquées sont
              présentées à titre indicatif et général sans valeur contractuelle.
            </p>
          </section>

          <hr className="border-gray-100" />

          <section data-testid="legal-article-6">
            <h2
              className="text-2xl font-black mb-4"
              style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
            >
              Article 6 : Liens hypertextes
            </h2>
            <p className="text-sm leading-relaxed">
              Des liens hypertextes peuvent être présents sur le site. L'Utilisateur est informé qu'en cliquant sur
              ces liens, il sortira du site Grainette.fr. Ce dernier n'a pas de contrôle sur les pages web sur lesquelles
              aboutissent ces liens et ne saurait, en aucun cas, être responsable de leur contenu.
            </p>
          </section>

          <hr className="border-gray-100" />

          <section data-testid="legal-article-7">
            <h2
              className="text-2xl font-black mb-4"
              style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
            >
              Article 7 : Cookies
            </h2>
            <p className="text-sm leading-relaxed">
              L'Utilisateur est informé que lors de ses visites sur le site, un cookie peut s'installer automatiquement
              sur son logiciel de navigation. Les cookies sont de petits fichiers stockés temporairement sur le disque dur
              de l'ordinateur de l'Utilisateur nécessaires à l'utilisation du site. Ils ne contiennent aucune information
              personnelle. L'Utilisateur peut désactiver ces cookies via les paramètres de son navigateur.
            </p>
          </section>

          <hr className="border-gray-100" />

          <section data-testid="legal-article-8">
            <h2
              className="text-2xl font-black mb-4"
              style={{ fontFamily: 'Barlow, sans-serif', color: '#2A3630' }}
            >
              Article 8 : Droit applicable
            </h2>
            <p className="text-sm leading-relaxed">
              La législation française s'applique au présent contrat. En cas d'absence de résolution amiable d'un
              litige né entre les parties, les tribunaux français seront seuls compétents pour en connaître. Pour toute
              question relative à l'application des présentes CGU, vous pouvez joindre l'éditeur aux coordonnées
              inscrites à l'Article 1.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}
